"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _FieldInfo = _interopRequireDefault(require("../../form/FieldInfo"));

var _headerConfig = require("./headerConfig");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var HeaderDefinition = _flowRuntime["default"].tdz(function () {
  return _headerConfig.HeaderDefinition;
});

var Props = _flowRuntime["default"].type("Props", _flowRuntime["default"].object(_flowRuntime["default"].property("header", _flowRuntime["default"].ref(HeaderDefinition))));

var _default = function _default(_arg) {
  var header = _arg.header;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-header" // eslint-disable-next-line react/no-danger
    ,
    dangerouslySetInnerHTML: {
      __html: header.text
    }
  }), header.info && /*#__PURE__*/_react["default"].createElement(_FieldInfo["default"], {
    className: header.key,
    info: header.info
  }));
};

exports["default"] = _default;